import React, { FC } from "react";
import { Outlet } from "react-router-dom";
import styles from "./AppLayout.module.css";
import Header from "../Header/Header";
import NavBar from "../NavBar/NavBar";
import { useAuthStore } from "src/features/auth";
import clsx from "clsx";
import { hasOnlyRole } from "@myapp/contract";

const AppLayout: FC = () => {
  const { user } = useAuthStore()
  const isWorker = hasOnlyRole(user?.roles ?? [], 'WORKER')
  return (
    <div className={styles.page}>
      <Header />
      <div className={clsx(styles.pageRow, 'md:pt-[60px]')} >
        <NavBar />
        <div className={clsx(styles.main, 'AppLayout', isWorker && styles.workerMain)}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AppLayout;